<template>
  <component :is="isTab ? 'div' : 'v-card'">
    <v-card-title>
      <v-spacer></v-spacer>
      <v-text-field
        dense
        hide-details
        append-icon="mdi-magnify"
        v-model="search"
        label="Search for policy"
        single-line
        class="shrink"
      ></v-text-field>
    </v-card-title>
    <v-card-text v-if="policies.filter((item) => item.data.length).length">
      <template v-for="(item, itemKey) of filteredPolicies">
        <h2
          class="mb-4"
          style="text-align: center"
          :key="itemKey"
          v-if="item.data.length"
        >
          {{ item.Type_Description }}
        </h2>
        <v-row :key="item.Policy_Type_ID * 25" justify="center">
          <v-col
            v-for="(concrete, concreteKey) in item.data"
            cols="12"
            md="6"
            lg="4"
            :key="concreteKey"
          >
            <v-card class="mb-3">
              <v-card-text>
                <v-row class="align-center">
                  <v-col cols="12" md="7" lg="7" sm="5">
                    <a
                      style="text-decoration: none"
                      :href="concrete.Link_To_Policy_On_Intranet"
                      target="_blank"
                    >
                      <h3>{{ concrete.Policy_Title }}</h3>
                    </a>
                  </v-col>
                  <v-col cols="12" md="3" lg="3" sm="5">
                    <h3 style="text-align: right">Agreed</h3>
                  </v-col>
                  <v-col cols="12" md="1" lg="1" sm="2">
                    <v-switch
                      v-model="concrete.Agreed"
                      @click="changeAgreement(concrete)"
                    >
                    </v-switch>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </template>
    </v-card-text>
    <v-card-text v-else>
      <h5>
        {{
          (user.employee_id === employee.Employee_ID
            ? "You don't"
            : "This employee doesn't") + " have assigned policies"
        }}
      </h5>
    </v-card-text>
  </component>
</template>

<script>
export default {
  props: {
    value: {
      required: false,
      type: Boolean,
      default: false
    },
    employee: {
      required: false,
      default: null
    },
    isTab: {
      required: false,
      default: false
    }
  },
  mounted () {
    this.getPersonalPolicies()
  },
  data () {
    return {
      policies: [],
      search: ''
    }
  },
  computed: {
    user () {
      return this.$store.getters.getUser
    },
    filteredPolicies () {
      if (!this.search) return this.policies
      let result = []
      result = JSON.parse(JSON.stringify(this.policies))
      for (let i = 0; i < this.policies.length; i++) {
        for (let j = 0; j < this.policies[i].data.length; j++) {
          if (
            !this.policies[i].data[j].Policy_Title.toLowerCase().includes(
              this.search.toLowerCase()
            )
          ) {
            result[i].data = result[i].data.filter(
              (item) =>
                item.Policy_Title !== this.policies[i].data[j].Policy_Title
            )
          }
        }
      }
      return result
    }
  },
  methods: {
    changeAgreement (policy) {
      this.axios
        .put(
          '/api/employee_change_agreement',
          {
            Employee_ID: this.employee.Employee_ID,
            Policy_ID: policy.Policy_ID,
            Agreed: policy.Agreed,
            IsNotificationRequired: !this.isTab
          },
          {
            headers: {
              Authorization: 'Bearer ' + this.user.token
            }
          }
        )
        .then(() => {
          if (!this.isTab) {
            this.$emit('updatePolicyUserCount', {
              employeeId: this.employee.Employee_ID,
              value: policy.Agreed ? 1 : -1
            })
            if (!policy.Agreed) {
              this.axios
                .post(
                  '/api/emails/sendemailonpolicyrevision',
                  {
                    employeeIDs: this.employee.Employee_ID,
                    Policy_Title: policy.Policy_Title,
                    Policy_Type: policy.Type_Description,
                    Link_To_Intranet: policy.Link_To_Policy_On_Intranet
                  },
                  {
                    headers: {
                      Authorization: 'Bearer ' + this.user.token
                    }
                  }
                )
                .then(() => {
                  this.$store.dispatch('setSuccess', {
                    successMsg:
                      'Agreement was successfully changed (Email was sent)'
                  })
                })
                .catch((error) => {
                  this.$store.dispatch('setError', {
                    errorMsg:
                      error.message + error.response
                        ? '' - '' + error.response.data
                        : ''
                  })
                })
            } else {
              this.$store.dispatch('setSuccess', {
                successMsg: 'Agreement was successfully changed'
              })
            }
          } else {
            this.$store.dispatch('setSuccess', {
              successMsg: 'Agreement was successfully changed'
            })
          }
        })
        .catch((error) => {
          this.$store.dispatch('setError', { errorMsg: error.message + ' - ' })
          policy.Agreed = !policy.Agreed
        })
    },
    getPersonalPolicies () {
      this.axios
        .get('/api/employee_personal_policies/' + this.employee.Employee_ID, {
          headers: {
            Authorization: 'Bearer ' + this.user.token
          }
        })
        .then((result) => {
          this.policies = result.data
        })
        .catch((error) => {
          this.$store.dispatch('setError', {
            errorMsg: error.message + ' - ' + error.response.data
          })
        })
    }
  },
  watch: {
    employee (oldVal, newVal) {
      this.getPersonalPolicies()
    }
  }
}
</script>
